import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.25 6.25L3.75 8.75L7.5 3.75"
      stroke="#05034D"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.25 13.75L3.75 16.25L7.5 11.25"
      stroke="#05034D"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <line
      x1="10.625"
      y1="6.875"
      x2="18.125"
      y2="6.875"
      stroke="#05034D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
    <line
      x1="10.625"
      y1="14.375"
      x2="18.125"
      y2="14.375"
      stroke="#05034D"
      stroke-width="1.25"
      stroke-linecap="round"
    />
  </svg>
);

const CheckboxIcon = (props) => <Icon component={svg} {...props} />;

export default CheckboxIcon;
